// src/Api/CompanyConfigApi.js
import { authFetch } from "../Utils/authFetch";

const API_BASE = process.env.REACT_APP_API_URL;

/* =========================
   Sidebar
========================= */

export async function getSidebarConfig(companyId) {
  const url = `${API_BASE}/getSidebarConfig?companyId=${encodeURIComponent(
    companyId
  )}`;
  const res = await authFetch(url, { method: "GET" });

  if (!res.ok) {
    let err;
    try {
      err = await res.json();
    } catch {}
    throw new Error(err?.error || "getSidebarConfig failed");
  }
  return res.json();
}

export async function updateSidebarConfig(companyId, items) {
  const url = `${API_BASE}/updateSidebarConfig`;
  const res = await authFetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ companyId, items }),
  });

  if (!res.ok) {
    let err;
    try {
      err = await res.json();
    } catch {}
    throw new Error(err?.error || "updateSidebarConfig failed");
  }
  return res.json();
}


export async function getSettingsConfig(companyId) {
  const url = `${API_BASE}/getSettingsConfig?companyId=${encodeURIComponent(
    companyId
  )}`;
  const res = await authFetch(url, { method: "GET" });

  if (!res.ok) {
    let err;
    try {
      err = await res.json();
    } catch {}
    throw new Error(err?.error || "getSettingsConfig failed");
  }
  return res.json();
}

/* =========================
   Frontpage
========================= */

export async function getFrontpageConfig(companyId) {
  const url = `${API_BASE}/getFrontpageConfig?companyId=${encodeURIComponent(
    companyId
  )}`;
  const res = await authFetch(url, { method: "GET" });

  if (!res.ok) {
    let err;
    try {
      err = await res.json();
    } catch {}
    throw new Error(err?.error || "getFrontpageConfig failed");
  }
  return res.json();
}

export async function updateFrontpageConfig(companyId, data) {
  const url = `${API_BASE}/updateFrontpageConfig`;
  const res = await authFetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ companyId, data }),
  });

  if (!res.ok) {
    let err;
    try {
      err = await res.json();
    } catch {}
    throw new Error(err?.error || "updateFrontpageConfig failed");
  }
  return res.json();
}
